import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DesuscripcionMail } from './model/DesuscripcionMail';
import { DesuscripcionDeNotificacionesService } from './services/desuscripcion-de-notificaciones.service';
import { TranslateService } from '@ngx-translate/core';
import { GenericToasterService } from 'src/app/core/services/generic-toaster.service';
import { MotivoDesuscripcion } from './model/MotivoDesuscripcion.model';
import { DesuscripcionTotalParams } from './model/DesuscripcionTotalParams';
import { MotivoDesuscripcionNotificacion } from './model/MotivoDesuscripcionNotificacion';

@Component({
  selector: 'app-desuscripcion-de-notificaciones',
  templateUrl: './desuscripcion-de-notificaciones.component.html',
  styleUrls: ['./desuscripcion-de-notificaciones.component.scss']
})
export class DesuscripcionDeNotificacionesComponent implements OnInit {

  loading: boolean = false;
  motivos: MotivoDesuscripcion[] = [];
  notificacion: string = '';
  desuscripcionMail: DesuscripcionMail;
  enviado: boolean = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private desuscripcionDeNotificacionesService: DesuscripcionDeNotificacionesService,
    private translate: TranslateService,
    private genericToasterService: GenericToasterService
  ) { }

  desuscripcionForm: UntypedFormGroup = this.formBuilder.group({
    motivo: [0],
    desuscribirTodas: [false]
  });

  async ngOnInit() {
    this.loading = true;
    await this.getUserData(this.getUrlParameter());
    await this.PostDesuscripcionUsuario(this.desuscripcionMail);
    await this.getMotivosDesuscripcion();
  }

  getUrlParameter(): string {
    const result = this.route.snapshot.paramMap.get('userData') || '';
    return result;
  }


  async getUserData(userEncriptedData: string) {
    try {
      const userInfo = await this.desuscripcionDeNotificacionesService.GetUserData(userEncriptedData);
      if (userInfo === undefined) {
        return;
      }
      this.desuscripcionMail = userInfo;
      this.notificacion = this.desuscripcionMail.tipoNotificacion;
    }
    catch (error) {
      this.genericToasterService.pushError(this.translate.instant('ERROR_APLICACION'));
    }
  }

  async PostDesuscripcionUsuario(desuscripcionMail: DesuscripcionMail) {
    try {
      await this.desuscripcionDeNotificacionesService.PostDesuscripcionUsuario(desuscripcionMail);
      this.loading = false;
    }
    catch (error) {
      this.genericToasterService.pushError(this.translate.instant('ERROR_APLICACION'));
    }
  }

  async PutMotivoDesuscripcion(params: MotivoDesuscripcionNotificacion) {
    try {
      await this.desuscripcionDeNotificacionesService.PutMotivoDesuscripcion(params);
    }
    catch (error) {
      this.genericToasterService.pushError(this.translate.instant('ERROR_APLICACION'));
    }
  }

  async PostDesuscripcionTotal(params: DesuscripcionTotalParams) {
    try {
      await this.desuscripcionDeNotificacionesService.PostDesuscripcionTotal(params);
    }
    catch (error) {
      this.genericToasterService.pushError(this.translate.instant('ERROR_APLICACION'));
    }
  }

  async getMotivosDesuscripcion() {
    try {
      this.motivos = await this.desuscripcionDeNotificacionesService.GetMotivosDesuscripcion() ?? [];
      this.desuscripcionForm.controls['motivo'].setValue(this.motivos.find(x => x.resourceKey == "Default"));
      this.motivos = this.motivos.filter(x => x.resourceKey != "Default");
    }
    catch (error) {
      this.genericToasterService.pushError(this.translate.instant('ERROR_APLICACION'));
    }
  }

  async send() {
    this.loading = true;

    if(this.desuscripcionForm.value.motivo.resourceKey != "Default"){
      const desuscripcionUsuarioParams: MotivoDesuscripcionNotificacion = {
        email: this.desuscripcionMail.userEmail,
        idMotivo: this.desuscripcionForm.value.motivo.id,
        tipoNotificacion: this.desuscripcionMail.tipoNotificacion,
        motivoDescripcion: this.desuscripcionForm.value.motivo.resourceKey
      }
      await this.PutMotivoDesuscripcion(desuscripcionUsuarioParams);
    }
    
    if (this.desuscripcionForm.value.desuscribirTodas) {
      const desuscripcionTotalParams: DesuscripcionTotalParams = {
        email: this.desuscripcionMail.userEmail,
        idMotivo: this.desuscripcionForm.value.motivo.id
      }
      await this.PostDesuscripcionTotal(desuscripcionTotalParams);
    }
    this.loading = false;
    this.enviado = true;
  }
}
